import { createSelector } from 'reselect'
import { type AppState } from 'src/redux/app/app.store'
import { type ZoneOption } from 'src/redux/zone/zone.types'

export const selectZoneOptions = (state: AppState): ZoneOption[] => state.zone.zoneOptions
export const selectAllZones = (state: AppState) => state.zone.allZones
export const selectZoneStringOptions = createSelector([selectZoneOptions], zoneOptions =>
    zoneOptions.map(({ label }) => {
        return { value: label, label }
    }),
)
export const selectZoneParkingAssistantSettings = (state: AppState) => state.zone.zoneParkingAssistantSettings
